'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const clsx = require('clsx');
const React = require('react');
const reactAriaComponents = require('react-aria-components');
const designSystem = require('@zapier/design-system');
const Select_SelectContext = require('./SelectContext.cjs.js');

const selectItem = "_select-item_1g2zo_1";
const styles = {
	selectItem: selectItem
};

const SelectItem = ({ children, className, isDisabled = false, iconName, size, textValue, value }) => {
  const { registerDisabledItem } = Select_SelectContext.useSelectContext();
  React.useEffect(() => {
    if (isDisabled) {
      registerDisabledItem(value || "");
    }
  }, [isDisabled, value, registerDisabledItem]);
  return react.jsx(
    reactAriaComponents.ListBoxItem,
    { className: clsx.clsx(className, styles.selectItem), "data-size": size, "data-zds": true, id: value, textValue },
    iconName && react.jsx(designSystem.Icon, { name: iconName, size: 16 }),
    children
  );
};

exports.SelectItem = SelectItem;
//# sourceMappingURL=SelectItem.cjs.js.map
